import { c as _c } from "react/compiler-runtime";
import { Alert, AlertTitle, AlertDescription } from "@repo/ui/components/ui/alert";
import { Button } from "@repo/ui/components/ui/button";
import { Body } from "@repo/ui/components/ui/text";
type ErrorFallbackProps = {
  error: unknown;
  componentStack?: string;
  resetError: () => void;
  showErrorMessage?: boolean;
};

/**
 * Default styled error fallback UI component for ErrorBoundary.
 *
 * This component provides a styled error UI using Alert, Button, and Text components.
 * It's used as the default fallback by the ErrorBoundary wrapper in this package.
 *

 */
export function ErrorBoundaryFallback(t0) {
  const $ = _c(10);
  const {
    error,
    resetError,
    showErrorMessage
  } = t0;
  const errorMessage = error ? typeof error === "string" ? error : error instanceof Error ? error.message : "An unknown error occurred" : "An unknown error occurred";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AlertTitle>Something went wrong</AlertTitle>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="mb-4">We've been notified about this issue and are working to fix it.</p>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== errorMessage || $[3] !== showErrorMessage) {
    t3 = showErrorMessage && errorMessage ? <Body>{errorMessage}</Body> : null;
    $[2] = errorMessage;
    $[3] = showErrorMessage;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== resetError) {
    t4 = <Button variant="fill" intent="danger" onClick={resetError}>Try again</Button>;
    $[5] = resetError;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <Alert variant="destructive">{t1}<AlertDescription>{t2}{t3}{t4}</AlertDescription></Alert>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}